import type { Example } from '../types';

export const colorPickerExample: Example = {
  id: 'color-picker',
  title: 'Color Picker & Swatches',
  categoryId: 'parameters',
  description: 'Full color picker, alpha channel, and predefined swatches',
  scadCode: `/* Color Picker & Swatches */

// markdown:tip
// **Color Picker** — Annotate any variable with \`// color\` to get a
// full-featured color picker. Add hex swatches in the comment for quick
// one-click color switching. A 4-element array adds an **alpha** slider.

/* [Colors] */

// Top color — click a swatch or open the picker
// color [#e74c3c, #e67e22, #f1c40f, #2ecc71, #3498db, #9b59b6]
top_color = [0.91, 0.3, 0.24];

// Bottom color
// color [#1a1a2e, #16213e, #0f3460, #533483]
bottom_color = [0.1, 0.13, 0.18];

// Accent ring — 4-element array adds an alpha slider
// color
accent_color = [1.0, 0.84, 0.0, 0.85];

/* [Shape] */

// Outer radius
outer_r = 35; // [15:1:60]

// Inner hole radius
inner_r = 12; // [3:1:30]

// Height
total_h = 24; // [8:1:50]

// Split height (top/bottom boundary)
split_h = 12; // [2:1:$total_h]

$fn = 80;

// --- parameters end ---

// Bottom half
color(bottom_color)
cylinder(r=outer_r, h=split_h, center=false);

// Top half
color(top_color)
translate([0, 0, split_h])
difference() {
  cylinder(r=outer_r, h=total_h - split_h, center=false);
  translate([0, 0, -0.5])
    cylinder(r=inner_r, h=total_h - split_h + 1, center=false);
}

// Accent ring around the split
color(accent_color)
translate([0, 0, split_h - 1.5])
difference() {
  cylinder(r=outer_r + 2, h=3, center=false);
  translate([0, 0, -0.5])
    cylinder(r=outer_r - 0.5, h=4, center=false);
}
`,
};
